import React from "react";

import { ErrorIcon, InfoIcon, SuccessIcon, WarningIcon } from "./icons";
import { noop } from "@/util/common";
import {
  AlertContentGrid,
  TitleWrapper,
  BodyWrapper,
  IconWrapper,
  XIconWrapper,
  IconSection,
} from "./Alert.styled";

import CloseIcon from "@/components/generic/CloseIcon";
import { ALERT_LEVELS } from "./constants";

export const ALERT_ICONS = {
  [ALERT_LEVELS.SUCCESS]: SuccessIcon(),
  [ALERT_LEVELS.INFO]: InfoIcon(),
  [ALERT_LEVELS.WARNING]: WarningIcon(),
  [ALERT_LEVELS.ERROR]: ErrorIcon(),
};

const Alert = ({
  alertLevel = ALERT_LEVELS.INFO,
  title = "",
  text = "",
  onClose = noop,
}) => {
  const safeAlertLevel = Object.values(ALERT_LEVELS).includes(alertLevel)
    ? alertLevel
    : ALERT_LEVELS.INFO;
  return (
    <AlertContentGrid alertLevel={safeAlertLevel}>
      <IconSection>
        <IconWrapper>{ALERT_ICONS[safeAlertLevel]}</IconWrapper>
      </IconSection>
      <TitleWrapper data-qa="Alert title">{title}</TitleWrapper>
      <BodyWrapper data-qa="Alert text">{text}</BodyWrapper>
      <XIconWrapper type="button" aria-label="Close alert" onClick={onClose}>
        <CloseIcon />
      </XIconWrapper>
    </AlertContentGrid>
  );
};

export default Alert;
